import { render, staticRenderFns } from "./ComboboxSelo.vue?vue&type=template&id=5879aeb4"
import script from "./ComboboxSelo.vue?vue&type=script&lang=js"
export * from "./ComboboxSelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports